<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import Tile, { TileProps } from '../components/Tile.svelte';
    import { redirectTo } from '../scripts/router1';
    import { idPageRegistration } from '../scripts/router2';
    import { storeLanguage, lang_fr } from "../scripts/store";

    const tile01_fr: TileProps = {
        icon: "../assets/images/tile08.png",
        title: "Etre moteur du changement",
        text: "En participant à des chantiers ou même en étant responsable de l'un d'entre eux, vous aurez la capacité à insuffler une dynamique forte tout en capitalisant sur les entreprises membres."
    }

    const tile02_fr: TileProps = {
        icon: "../assets/images/tile04.png",
        title: "La visibilité",
        text: "Via notre site internet, les réseaux sociaux et des propositions de prises de paroles en sessions plénières, votre marque disposera d'une visibilité accrue et pérenne dans un écosystème mouvant."
    }

    const tile03_fr: TileProps = {
        icon: "../assets/images/tile05.png",
        title: "Un réseau étendu",
        text: "En intégrant notre collectif, vous bénéficiez immédiatement d'un réseau de 100 entreprises membres prêtes à partager leurs bonnes pratiques, ainsi que plusieurs partenaires qui nous apportent expérience, expertise et savoir-faire."
    }

    const tile04_fr: TileProps = {
        icon: "../assets/images/tile09.png",
        title: "Ensemble, plus loin",
        text: "Échangez avec des entreprises de tous secteurs d'activité pour créer une ouverture toujours plus grande, toujours plus qualitative et respectueuse de l'environnement. 2 retours d'expériences concrets sont proposés à chaque session plénière. Un groupe Slack est opérationnel."
    }
    
    const tile05_fr: TileProps = {
        icon: "../assets/images/tile07.png",
        title: "Soyez à l'écoute",
        text: "La veille technologique vous est servie sur un plateau chaque mois dans la revue de presse : prête à être consommée."
    }
    
    const tile06_fr: TileProps = {
        icon: "../assets/images/tile10.png",
        title: "Libéré, délivré",
        text: "Livres blancs, formations, baromètre, guide de bonnes pratiques : venez participer à l'écriture de nos livrables pour délivrer l'ouverture des systèmes d'information."
    }
    
    const tile01_en: TileProps = {
        icon: "../assets/images/tile08.png",
        title: "Be a driver of change",
        text: "By participating in projects or even by being responsible for one of them, you will have the ability to instill a strong dynamic while capitalizing on member companies."
    }

    const tile02_en: TileProps = {
        icon: "../assets/images/tile04.png",
        title: "The visibility",
        text: "Via our website, social networks and proposals for speeches in plenary sessions, your brand will have increased and lasting visibility in a changing ecosystem."
    }

    const tile03_en: TileProps = {
        icon: "../assets/images/tile05.png",
        title: "An extended network",
        text: "By joining our group, you immediately benefit from a network of 100 member companies ready to share their best practices, as well as several partners who bring us experience, expertise and know-how."
    }

    const tile04_en: TileProps = {
        icon: "../assets/images/tile09.png",
        title: "Together, further",
        text: "Discuss with companies from all sectors of activity to create ever greater openness, ever more qualitative and respectful of the environment. 2 practical feedbacks are offered at each plenary session. A Slack group is operational."
    }
    
    const tile05_en: TileProps = {
        icon: "../assets/images/tile07.png",
        title: "Be in tune",
        text: "The technological watch is served to you on a plate each month in the press review: ready to be consumed"
    }
    
    const tile06_en: TileProps = {
        icon: "../assets/images/tile10.png",
        title: "Freed, freed",
        text: "White papers, training, barometer, good practice guide: come and participate in the writing of our deliverables to deliver the opening of information systems"
    }
    
    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .devenirmembre {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 60px 32px;
            width: 100%;
        }
        &__contact {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid $color-primary;
            border-radius: 5px;
            background-color: $color-primary;
            color: $color-white;
            transition: all;
            transition-duration: 0.5s;
            margin: 15px 10px 60px 10px;
            padding: 15px 15px 15px 15px;
            min-width: 150px;
        }
    }

    @include large {
        .devenirmembre {
            &__tiles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__tile {
                height: 100%;
                width: 30%;
            }
            &__contact {
                cursor: pointer;
                &:hover {
                    border: 1px solid $color-orange;
                    color: $color-orange;
                    transform: scale(1.1);
                }
            }
        }
    }

</style>

<div class="devenirmembre">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Devenir membre"/>
    {:else}
    <PageHeader props="To become member"/>
    {/if}
    <div class="bloc devenirmembre__bloc">
        <div class="devenirmembre__title">
            <p>
                {#if ($storeLanguage == $lang_fr)}
                En tant que membre, vous devenez acteur d'une communauté dynamique où passionnés et experts des APIs se rassemblent pour échanger, innover et partager. Imaginez un espace où vos idées prennent vie, où chaque rencontre est une opportunité de grandir et de vous démarquer !
                {:else}
                As a member, you become an actor in a dynamic community where API enthusiasts and experts come together to exchange, innovate and share. Imagine a space where your ideas come to life, where each meeting is an opportunity to grow and stand out!
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Ce que nous vous offrons :
                <ul>
                    <li>
                        Des sessions plénières trimestrielles pour décrypter les tendances et partager vos expériences.
                    </li>
                    <li>
                        Des chantiers thématiques pour travailler ensemble sur des projets API concrets.
                    </li>
                    <li>
                        Un blog exclusif où vous pouvez publier et consulter des articles sur vos sujets de prédilection.
                    </li>
                    <li>
                        Des opportunités de réseautage pour croiser le chemin d'autres professionnels et influenceurs du secteur.
                    </li>
                    <li>
                        Un accès VIP à France API, l'événement incontournable des passionnés d'APIs.
                    </li>
                </ul>
                {:else}
                What we offer you:
                <ul>
                    <li>
                        Quarterly plenary sessions to decipher trends and share your experiences.
                    </li>
                    <li>
                        Thematic workshops to work together on concrete API projects.
                    </li>
                    <li>
                        An exclusive blog where you can publish and consult articles on your favorite topics.
                    </li>
                    <li>
                        Networking opportunities to cross paths with other professionals and influencers in the sector.
                    </li>
                    <li>
                        VIP access to France API, the must-attend event for API enthusiasts.
                    </li>
                </ul>
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Pour être membre, il convient d'être client final, quel que soit le secteur d'activité : énergie, hospitalité, finance, assurance, retail, secteur public.
                {:else}
                To be a member, you must be an end customer, regardless of the sector of activity: energy, hospitality, finance, insurance, retail, public sector.
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Les ESN, éditeurs, formateurs... ne peuvent être membres : ils peuvent être partenaires. Avec un ticket d'entrée gratuit, chacun apporte sa vision et son expertise quand il le souhaite.
                {:else}
                ESNs, publishers, trainers, etc. cannot be members: they can be partners. With a free entry ticket, everyone brings their vision and expertise whenever they want.
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                La force du collectif fait le reste ! Nous sommes notre force.
                {:else}
                The strength of the collective does the rest! We are our strength.
                {/if}
            </p>
        </div>
        {#if ($storeLanguage == $lang_fr)}
        <div class="devenirmembre__tiles">
            <div class="devenirmembre__tile">
                <Tile props={tile01_fr}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile02_fr}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile03_fr}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile04_fr}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile05_fr}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile06_fr}/>
            </div>
        </div>    
        {:else}
        <div class="devenirmembre__tiles">
            <div class="devenirmembre__tile">
                <Tile props={tile01_en}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile02_en}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile03_en}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile04_en}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile05_en}/>
            </div>
            <div class="devenirmembre__tile">
                <Tile props={tile06_en}/>
            </div>
        </div>    
        {/if}
        <div class="devenirmembre__contact" on:click={()=> redirectTo(idPageRegistration)} on:keydown={()=> redirectTo(idPageRegistration)}>
            {#if ($storeLanguage == $lang_fr)}
            Je souhaite devenir membre
            {:else}
            I want to become a member
            {/if}
        </div>
    </div>
</div>
